import { NotificationService } from "@cradua/core";
import { Injectable } from "@angular/core";
import { createEffect, Actions, ofType } from "@ngrx/effects";
import {
  map,
  catchError,
  concatMap,
  exhaustMap,
  first,
  withLatestFrom,
  switchMap,
} from "rxjs/operators";
import { of } from "rxjs";
import * as AcquisitionActions from "./acquisition.actions";
import { AcquisitionService } from "../../services/acquisition.service";
import {
  AcquisitionStoreSelectors,
  AcquisitionStoreReducer,
} from "./index";
import { select, Store } from "@ngrx/store";

@Injectable()
export class AcquisitionEffects {
  loadAcquisition$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AcquisitionActions.loadAcquisition),
      exhaustMap((_) =>
        this.acquisitionService.getAcquisition().pipe(
          map((data) =>
            AcquisitionActions.loadAcquisitionSuccess({
              Acquisition: data,
            })
          ),
          catchError((error) =>
            of(
              AcquisitionActions.loadAcquisitionFailure({
                error,
              }),
            )
          ),
        )
      ),
    )
  );


  clearAcquisition$ = createEffect(() =>
  this.actions$.pipe(
    ofType(AcquisitionActions.clearAcquisition),
    exhaustMap((_) => of(AcquisitionActions.loadAcquisitionSuccess({
            Acquisition: [],
          }))))
);

  fetchAcquisitionRecord$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AcquisitionActions.fetchAcquisitionRecord),
      switchMap(({ fetch }) =>
        of(fetch).pipe(
          withLatestFrom(
            this.store.select(AcquisitionStoreSelectors.getAllAcquisition),
          ),
        )
      ),
      switchMap(([result, res]) => {
        // console.log("result ", res);
        return this.acquisitionService.fetchAcquisition(result).pipe(
          map((data) =>
            AcquisitionActions.fetchAcquisitionRecordSuccess({ record: data })
          ),
          catchError((error) => {
            this.notification.error(error.error.message);
            return of(
              AcquisitionActions.fetchAcquisitionRecordFailure({ error }),
            );
          }),
        );
      }),
    )
  );

  fetchByIdAcquisitionRecord$ = createEffect(() =>
  this.actions$.pipe(
    ofType(AcquisitionActions.fetchByIdAcquisitionRecord),
    switchMap(({ id }) =>
      of(id).pipe(
        withLatestFrom(
          this.store.select(AcquisitionStoreSelectors.getAllAcquisition),
        ),
      )
    ),
    switchMap(([result, res]) => {
      return this.acquisitionService.fetchByIdAcquisition(result).pipe(
        map((data) =>
          AcquisitionActions.fetchByIdAcquisitionRecordSuccess({ record: data })
        ),
        catchError((error) => {
          this.notification.error(error.error.message);
          return of(
            AcquisitionActions.fetchByIdAcquisitionRecordFailure({ error }),
          );
        }),
      );
    }),

  )
);


  addAcquisition$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AcquisitionActions.addAcquisition),
      concatMap(({ newAcquisition }) =>
        this.acquisitionService.createAcquisition(newAcquisition)
          .pipe(
            map((data) => {
              this.notification.success("Saved Successfully");
              return AcquisitionActions.addAcquisitionSuccess(
                {
                  newAcquisition: data,
                },
              );
            }),
            catchError((error) =>
              of(
                AcquisitionActions.addAcquisitionFailure(
                  { error: error.error.message },
                ),
              )
            ),
          )
      ),
    )
  );

  updateAcquisition$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AcquisitionActions.updateAcquisition),
      map((action) => action.updateAcquisition),
      concatMap((updateAcquisition) =>
        this.acquisitionService
          .updateAcquisition(updateAcquisition)
          .pipe(
            map((mapAcquisition) => {
              // console.log('update ', mapAcquisition)
              this.notification.success("Updated Successfully");
              return AcquisitionActions.updateAcquisitionSuccess(
                {
                  updateAcquisition: mapAcquisition,
                },
              );
            }),
            catchError((error) =>
              of(
                AcquisitionActions.updateAcquisitionFailure(
                  { error: error.message },
                ),
              )
            ),
          )
      ),
    )
  );

  removeAcquisition$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AcquisitionActions.removeAcquisition),
      map((action) => action.id),
      concatMap((id) =>
        this.acquisitionService
          .deleteAcquisition(id)
          .pipe(
            map(() => {
              this.notification.success("Deleted Successfully");
              return AcquisitionActions.removeAcquisitionSuccess(
                { id },
              );
            }),
            catchError((error) =>
              of(
                AcquisitionActions.updateAcquisitionFailure(
                  { error: error.message },
                ),
              )
            ),
          )
      ),
    )
  );

  constructor(
    private actions$: Actions,
    private store: Store<AcquisitionStoreReducer.AcquisitionPartialState>,
    private acquisitionService: AcquisitionService,
    private notification: NotificationService,
  ) {}
}
